module.exports = __webpack_public_path__ + "images/modern-3-33efedd9eee24d934c23635905095720.jpg";